import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "NewDocument.svg",
  "use": "NewDocument.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"NewDocument.svg\"><path d=\"M37.0106,22.0208a1,1,0,0,1-1-1V10.4351a1,1,0,0,1,1.707-.7072l10.586,10.5859a1,1,0,0,1-.7072,1.707Zm13,5v26a3,3,0,0,1-3,3h-30a3,3,0,0,1-3-3v-42a3,3,0,0,1,3-3h14a3,3,0,0,1,3,3v10a3,3,0,0,0,3,3h10A3,3,0,0,1,50.01,27.0208Zm-9,11a1,1,0,0,0-1-1h-6v-6a1,1,0,0,0-1-1h-2a1,1,0,0,0-1,1v6h-6a1,1,0,0,0-1,1v2a1,1,0,0,0,1,1h6v6a1,1,0,0,0,1,1h2a1,1,0,0,0,1-1v-6h6a1,1,0,0,0,1-1Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol